import React from 'react';
import * as S from './styles';

interface ShellSkeletonProps {
  userThemeEnabled?: boolean;
}

const ShellSkeleton: React.FC<ShellSkeletonProps> = ({ userThemeEnabled }) => {
  return (
    <S.Page $userThemeEnabled={userThemeEnabled}>
      <S.Container $userThemeEnabled={userThemeEnabled}>
        <S.Content>
          <S.SkeletonItem
            className="shell-skeleton"
            height="30px"
            width="405px"
            marginBottom="10px"
            $userThemeEnabled={userThemeEnabled}
          />
          <S.SkeletonItem
            className="shell-skeleton"
            height="30px"
            width="105px"
            marginBottom="10px"
            $userThemeEnabled={userThemeEnabled}
          />
          <S.SkeletonItem
            className="shell-skeleton"
            height="30px"
            width="30px"
            $userThemeEnabled={userThemeEnabled}
          />
        </S.Content>
      </S.Container>
    </S.Page>
  );
};

export default ShellSkeleton;
